import { cx } from "@emotion/css";
import type { FC, InputHTMLAttributes, ReactNode } from "react";
import type { UseFormGetValues, UseFormRegisterReturn, UseFormSetValue } from "react-hook-form";

import CloseIcon from "@/assets/close.svg?react";

import { PlainLoading } from "..";

interface InputWithClearProps extends InputHTMLAttributes<HTMLInputElement> {
  register: UseFormRegisterReturn<any>;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
  helper?: ReactNode;
  styleType?: "shadow" | "outline";
  isLoading?: boolean;
}
export const InputWithClear: FC<InputWithClearProps> = ({
  register,
  setValue,
  getValues,
  className,
  helper,
  styleType = "outline",
  isLoading,
  ...props
}) => {
  return (
    <div className={cx("relative flex flex-col", className)}>
      <input
        className={cx([
          "form-input rounded-lg text-[14px] leading-[22px] outline-0",
          styleType === "shadow"
            ? "placeholder:font-normal placeholder:text-[14px] placeholder:leading-[22px] placeholder:text-[#404040] focus:border-[#737373] focus:shadow-none focus:ring-0 focus:ring-offset-0"
            : "placeholder:text-text-gray focus:border-transparent focus:ring-primary",
          "rounded-md",
          {
            "box-border h-[56px] border border-solid border-[#737373] bg-[#F2F4F5] px-3 py-[17px]":
              styleType === "shadow",
            "border-solid border-[#E3E5E5] p-3": styleType === "outline",
          },
          props.disabled || "pr-8",
          props.disabled && "bg-[#F7F9FA]",
        ])}
        style={{ boxShadow: "0 0 #0000" }}
        {...props}
        {...register}
      />
      <span
        className={cx(
          "absolute right-0 top-1/2 flex h-4 -translate-y-1/2 items-center p-4",
          getValues(register.name) || getValues(register.name) === 0 || "hidden",
          props.disabled && "hidden"
        )}
        onClick={() => setValue(register.name, "")}
      >
        <CloseIcon className={cx("h-4 w-4")} />
      </span>
      {isLoading && (
        <PlainLoading className="absolute right-0 top-1/2 h-6 -translate-y-1/2 p-4" />
      )}
      {helper && (
        <div
          className={cx(
            "mt-2",
            styleType === "shadow"
              ? "text-[14px] font-normal leading-[22px] text-[#404040]"
              : "text-[15px] text-text-gray"
          )}
        >
          {helper}
        </div>
      )}
    </div>
  );
};
